import { Unionize } from "./generic";
import { User } from "./identities";
import { Layer, LayerIds } from "./layer";

export enum ExportStatus {
  Pending = "PENDING",
  InProgress = "IN_PROGRESS",
  Complete = "COMPLETE",
  Error = "ERROR",
}

export const ExportFormats = ["geojson", "shp", "kml", "tab"] as const;
export type ExportFormats = Unionize<typeof ExportFormats>;

const ExportFormatLabels: Record<ExportFormats, string> = {
  geojson: "GeoJSON",
  shp: "ShapeFile",
  kml: "KML",
  tab: "Tab",
};

export const getExportFormat = (format: ExportFormats): string => {
  return ExportFormatLabels[format];
};

export enum SystemsOfMeasurement {
  Metric = "metric",
  Imperial = "imperial",
}

export type ExportStatusDetails = {
  Value: ExportStatus;
  Message?: string;
  Progress?: number;
  JobID?: string;
};

export type ExportLayer = {
  ID: string;
  LayerKey: string;
};

export type ExportLayerWithLabel = {
  Label: string;
} & ExportLayer;

export type LayerWithLabel = {
  Label: string;
} & Layer;

export interface Export {
  ID: string;
  VersionID: string;
  CreatedAt: string;
  Creator: User;
  LastModifiedAt: string;
  LastModifiedBy: User;
  CompletedAt?: string;
  Format: ExportFormats;
  Name?: string;
  Description?: string;
  SystemOfMeasurement: SystemsOfMeasurement;
  BOM?: boolean;
  SpliceTables?: boolean;
  FiberCableSplit?: boolean;
  HubSplit?: boolean;
  SpliceSplit?: boolean;
  Layers: ExportLayer[];
  Status: ExportStatusDetails;
  Url?: string;
  FileSizeBytes?: number;
  InputDataArea: boolean;
  ConstructionPrints?: boolean;
}

export type CreateExportParams = Pick<
  Export,
  "VersionID" | "Description" | "BOM" | "SpliceTables" | "FiberCableSplit" | "HubSplit" | "SpliceSplit" | "ConstructionPrints"
> & {
  Name: string;
  Format: string;
  SystemOfMeasurement: string;
  Layers: string[];
};

export type ExportsByStatus = {
  InProgress: Export[];
  Complete: Export[];
  Error: Export[];
};

export const SplitByTier = {
  [LayerIds.hub]: "hubSplit",
  [LayerIds.splice]: "spliceSplit",
  [LayerIds.fibreCable]: "fiberCableSplit",
};

export enum ExportAccordionPanel {
  InProgress = "exports-in-progress",
  Complete = "project-exports",
}
